import React, { Component } from 'react';
import '../css/components/footer.css'

class Footer extends Component {

    render() {
        return (
            <footer className="cl_Footer">
                <p className="cl_FooterText"></p>
            </footer>
        );
    }
}

export default Footer